<div class="container">
  <h1>Novo ticket</h1>
  
  <form [formGroup]="ticketForm" (ngSubmit)="onSubmit()">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Título</mat-label>
      <input matInput formControlName="title" required>
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Descrição</mat-label>
      <textarea matInput formControlName="body" required rows="5"></textarea>
    </mat-form-field>

    <div class="button-container">
      <button mat-raised-button color="accent" type="button" (click)="onCancel()">Cancelar</button>
      <button mat-raised-button color="primary" type="submit" [disabled]="!ticketForm.valid">Criar</button>
    </div>
  </form>
</div>
